import { useEffect, useState } from "react";
import { SitePage } from "../../Models/SitePage";
import SitePageApi from "../../Api/SitePageApi";
// import { useParams } from 'react-router-dom';
import { PageType } from "../../Enums/PageType";
import { Button, Modal, TextInput, Textarea } from "flowbite-react";
import { ContactForm } from "../../Models/ContactForm";
import ContactFormApi from "../../Api/ContactFormApi";
import { toast } from "react-toastify";
import { renderHTML } from "../../Utils";
import Loader from "../Common/Loader";

export default function Contact() {
  //   const { id } = useParams();
  //   const { userModel } = useAppSelector((state) => state.user);
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState<ContactForm>({
    id: 0,
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    questionsComments: "",
    website: "",
    formOpenedAt: new Date().toISOString(),
    clientId: null,
    contactId: null,
  });

  useEffect(() => {
    //   getSitePages();
    getSitePage();
    handleSetInitialValues();
  }, []);
  const getSitePage = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageByPageType(PageType.Contact.toString())
        .then((res) => {
          setPageData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleSetInitialValues = () => {
    setFormData((prev) => ({
      ...prev,
      website: "",
      formOpenedAt: new Date().toISOString(),
    }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeTA = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const submitContactForm = () => {
    setButtonDisabled(true);
    setIsLoading(true);
    ContactFormApi.addContactForm(formData)
      .then((res) => {
        const data = res.data;
        if (!data?.success) {
          toast.error(
            data?.message || "Something went wrong. Please try again."
          );
          return;
        }
        toast.success(
          "Thank you! Your message was sent. We'll be in touch soon."
        );
        setShowSuccessModal(true);
        setFormData({
          id: 0,
          companyName: "",
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          subject: "",
          questionsComments: "",
          website: "",
          formOpenedAt: new Date().toISOString(),
          clientId: null,
          contactId: null,
        });
      })
      .catch((err: unknown) => {
        const ax = err as {
          response?: { data?: { message?: string; title?: string } };
        };
        const msg =
          ax?.response?.data?.message ??
          ax?.response?.data?.title ??
          "We could not send your message. Please try again or call us.";
        toast.error(msg);
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  return (
    <>
      <Modal show={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
        <Modal.Header>Message sent</Modal.Header>
        <Modal.Body>
          <p className="text-gray-700">
            Thank you for contacting Price Bros Equipment. We received your
            message and will follow up soon. A confirmation may also arrive by
            email.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="buttonMain" onClick={() => setShowSuccessModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="bg-white">
        {isLoading && <Loader />}
        {/* Banner Image */}
        <div className="w-full">
          <img
            src="https://pricebrosstorage.blob.core.windows.net/data/sitepages/Contact%20us%20page%20Header.png"
            alt="Price Bros Banner"
            className="h-56 sm:h-64 xl:h-72 2xl:h-80 w-auto mx-auto object-contain"
          />
        </div>

        {/* Contact Info + Form Section */}
        <div className="max-w-7xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-10 items-start">
          {/* Left: Contact Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">PRICE BROS EQUIPMENT</h3>
            {pageData?.description && (
              <div className="p-4 bg-white shadow-md">
                {pageData?.description && renderHTML(pageData?.description)}
              </div>
            )}
            <p className="italic">
              619 S. Washington
              <br />
              P.O. Box 3207
              <br />
              Wichita, KS 67201-3207
            </p>
            <p className="font-medium">
              <a href="tel:+13162659577" className="hover:underline">
                (316) 265-9577
              </a>
            </p>
            <p>
              <a
                href="mailto:parts@pricebroseq.com"
                className="text-blue-600 hover:underline"
              >
                parts@pricebroseq.com
              </a>
            </p>

            <div className="flex items-center gap-4 pt-4">
              <a href="https://www.facebook.com/PriceBrosEqAG/">
                <img src="/assets/facebook-48.png" className="w-6" />
              </a>
              <a href="https://www.instagram.com/pricebrosequipment_wichita/">
                <img src="/assets/instagram-48.png" className="w-6" />
              </a>
              <a href="https://www.youtube.com/PriceBrosEqAG">
                <img src="/assets/youtube-48.png" className="w-6" />
              </a>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div>
            <form
              id="contact-form"
              method="post"
              className="space-y-4 relative"
              onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                submitContactForm();
              }}
            >
              {/* Honeypot — hidden from users; bots that fill it are rejected */}
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  left: "-10000px",
                  top: "auto",
                  width: "1px",
                  height: "1px",
                  overflow: "hidden",
                }}
              >
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  name="website"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  value={formData.website ?? ""}
                  onChange={handleChange}
                />
              </div>
              <TextInput
                name="companyName"
                placeholder="Company Name"
                onChange={handleChange}
                value={formData.companyName ? formData.companyName : ""}
                required
              />
              <div className="grid grid-cols-2 gap-4">
                <TextInput
                  name="firstName"
                  placeholder="First Name"
                  onChange={handleChange}
                  value={formData.firstName ? formData.firstName : ""}
                  required
                />
                <TextInput
                  name="lastName"
                  placeholder="Last Name"
                  onChange={handleChange}
                  value={formData.lastName ? formData.lastName : ""}
                  required
                />
              </div>
              <TextInput
                name="phone"
                placeholder="Phone"
                onChange={handleChange}
                value={formData.phone ? formData.phone : ""}
              />
              <TextInput
                name="email"
                placeholder="Email"
                onChange={handleChange}
                value={formData.email ? formData.email : ""}
                required
              />
              <TextInput
                name="subject"
                placeholder="Subject"
                onChange={handleChange}
                value={formData.subject ? formData.subject : ""}
                required
              />
              <Textarea
                name="questionsComments"
                placeholder="Questions or Comments"
                onChange={handleChangeTA}
                value={
                  formData.questionsComments ? formData.questionsComments : ""
                }
                rows={4}
                required
              />
              <Button
                type="button"
                disabled={buttonDisabled}
                className="buttonMain "
                onClick={() => submitContactForm()}
              >
                Submit
              </Button>
            </form>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-t-4 border-yellow-400 my-10" />

        {/* Territory Section */}
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold uppercase mb-4">
            Equipment Territory Managers
          </h3>
          <p className="mb-8 text-gray-600">
            Located in their territory, you will find these team members at
            local farm shows, delivering equipment to your dealership and
            offering user support & demos.
          </p>

          {/* Territory Map */}
          <img
            src="https://pricebrosstorage.blob.core.windows.net/data/sitepages/image002.jpg"
            className="w-full max-w-4xl mx-auto mb-8"
            alt="Territory Map"
          />

          {/* Team Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 pb-10">
            {[
              {
                territory: "11",
                name: "Brently Frick",
                phone: "316.640.5867",
                email: "bfrick@pricebroseq.com",
                photo: "/images/frick.jpg",
                color: "green-500",
              },
              {
                territory: "12",
                name: "Kevin Allan",
                phone: "316.706.0691",
                email: "kallan@pricebroseq.com",
                photo: "/images/allan.jpg",
                color: "blue-500",
              },
              {
                territory: "13",
                name: "Kevin Mooney",
                phone: "316.213.0060",
                email: "kmooney@pricebroseq.com",
                photo: "/images/mooney.jpg",
                color: "red-500",
              },
              {
                territory: "15",
                name: "Trey Price",
                phone: "316.650.4842",
                email: "parts@pricebroseq.com",
                photo: "/images/trey.jpg",
                color: "yellow-500",
              },
            ].map((tm, idx) => (
              <div
                key={idx}
                className={`bg-white shadow-md rounded-md border-t-8 border-${tm.color} p-4 text-center`}
              >
                <p className="font-semibold text-lg">
                  Territory {tm.territory}
                </p>
                {/* <img
                  src={tm.photo}
                  className="mx-auto w-32 h-32 object-cover rounded-full my-2"
                /> */}
                <p className="font-bold">{tm.name}</p>
                <p className="text-sm italic">
                  Direct:{" "}
                  <a
                    href={`tel:${tm.phone}`}
                    className="text-blue-600 hover:underline"
                  >
                    {tm.phone}
                  </a>
                </p>
                <p className="text-sm">
                  <a
                    href={`mailto:${tm.email}`}
                    className="text-blue-600 hover:underline"
                  >
                    {tm.email}
                  </a>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
